import { memo } from 'react'
import { AgentMessage, MessageRole } from '@multiplayer-app/ai-agent-types'

interface MessageAvatarProps {
  message: AgentMessage
}

const getInitials = (message: AgentMessage) => {
  const label = message.sender?.displayName || message.sender?.id || message.agentName
  if (!label) return message.role === MessageRole.User ? 'You' : 'AI'

  const parts = label.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
  }
  return label.slice(0, 2).toUpperCase()
}

export const MessageAvatar = memo(({ message }: MessageAvatarProps) => {
  const isUser = message.role === MessageRole.User

  return (
    <div className={`mp-agent-message-avatar ${isUser ? 'mp-agent-message-avatar-user' : ''}`}>
      {message.sender?.avatarUrl ? (
        <img className='mp-agent-message-avatar-image' src={message.sender.avatarUrl} alt='' />
      ) : (
        <div className='mp-agent-message-avatar-icon'>{getInitials(message)}</div>
      )}
    </div>
  )
})

MessageAvatar.displayName = 'MessageAvatar'
